import { Skeleton } from '@mui/material';
import React from 'react'
import { useSelector } from 'react-redux'
import { getInitials } from '../CommonFile/Function_utils';

function APCreditData() {
    const { apollo_credit_data } = useSelector(state => state.data);

    const isData = Object.keys(apollo_credit_data).length > 0 ? true : false;
    // alert(isData)
    return (
        <div className="credit-summary-widget">

            <div className="user-profile">
                {/* <div className="avatar">
                    {apollo_credit_data?.first_name[0]}{apollo_credit_data?.last_name[0]}
                </div> */}
                <div className="profile-avatar-table">
                    {apollo_credit_data?.first_name && getInitials(apollo_credit_data?.first_name.trim())}
                </div>

                <div className="user-details">
                    <h6>{apollo_credit_data?.first_name} {apollo_credit_data?.last_name}</h6>
                    <p>{apollo_credit_data?.email}</p>
                </div>
            </div>

            <div className="summary-list">
                <div className="summary-item-heading">
                    <h5>Credit Details</h5>
                </div>

                <div className="summary-item">
                    <span className='summary-item-text'>
                        <i className='bx bx-cart-alt'></i>
                        Recently Purchased
                    </span>
                    <strong>{apollo_credit_data?.effective_num_direct_dial_credits ? apollo_credit_data?.effective_num_direct_dial_credits.toLocaleString() : 0}</strong>
                </div>

                <div className="summary-item">
                    <span className='summary-item-text'>
                        <i className='bx bx-layer'></i>
                        Total
                    </span>
                    <strong>{apollo_credit_data?.effective_num_lead_credits ? apollo_credit_data?.effective_num_lead_credits.toLocaleString() : 0}</strong>
                </div>

                <div className="summary-item">
                    <span className='summary-item-text'>
                        <i className='bx bx-minus-circle'></i>
                        Used
                    </span>
                    <strong>{apollo_credit_data?.effective_num_lead_credits ? apollo_credit_data?.effective_num_lead_credits - apollo_credit_data?.num_credits_remaining : 0}</strong>
                </div>


                <div className="summary-item remain">
                    <span className='summary-item-text remain-text'>
                        <i className='bx bx-wallet'></i>
                        Remaining
                    </span>
                    <strong>{apollo_credit_data?.num_credits_remaining ? apollo_credit_data?.num_credits_remaining.toLocaleString() : 0}</strong>
                </div>

            </div>

        </div>
    )
}

export default APCreditData
